import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { GalleryDialogComponent } from 'src/app/components/dialogs/gallery-dialog/gallery-dialog.component';
import { Gallery } from 'src/app/models/gallery';
import { SliderOptions, SliderTheme } from 'src/app/models/slider-options';
import { Static } from 'src/app/models/static';
import { DialogService } from 'src/app/services/dialog.service';
import { MainService } from 'src/app/services/main.service';
import { ResponsiveService } from 'src/app/services/responsive.service';

@Component({
  selector: 'app-static',
  templateUrl: './static.component.html',
  styleUrls: ['./static.component.scss'],
})
export class StaticComponent implements OnInit {
  document: Static;
  gallery: Gallery;
  sliderOptions: SliderOptions;
  maxImgWidth: number;

  constructor(
    public mainService: MainService,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private responsiveService: ResponsiveService
  ) {}

  ngOnInit(): void {
    this.maxImgWidth =
      this.responsiveService.containerWidth < 672
        ? this.responsiveService.containerWidth
        : 672;

    this.route.paramMap
      .pipe(
        switchMap((params: ParamMap) =>
          this.mainService.getStaticPage('/' + params.get('slug'))
        )
      )
      .subscribe((data: Static) => {
        this.document = data;
        if (!!this.document.gallery_id) {
          this.mainService
            .getGallery('/' + data.gallery_id)
            .subscribe((galleryData) => {
              this.gallery = galleryData;
              this.sliderOptions = new SliderOptions(
                this.gallery.image.length,
                { xs: 1, sm: 4 },
                true,
                SliderTheme.PRIMARY
              );
            });
        }
      });
  }

  openGallery(gallery: Gallery) {
    this.dialogService.openModalWithParams(GalleryDialogComponent, gallery);
  }
}
